module.exports = __webpack_public_path__ + "img/罂粟壳.b2d525ff.jpg";